import { render, staticRenderFns } from "./VariableSalaryModalBase.vue?vue&type=template&id=56d79450&"
import script from "./VariableSalaryModalBase.vue?vue&type=script&lang=ts&"
export * from "./VariableSalaryModalBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports